import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from "src/environments/environment";
import { MainStore } from '../main.store';
import { MsalService } from '@azure/msal-angular';
import { CtrlClickDirective } from '../../directives/ctrl-click.directive';
import { ErrorService } from '../errors/error.service';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CtrlClickDirective]
})
export class ErrorPageComponent  implements OnInit {

  failedJpg: string = '';
  somethingwentwrong: string = '';
  errorMsg: string = '';
  flippic: boolean = true;

  /** The error that routed the user here (set by ErrorService before navigation). Null on a hard refresh. */
  readonly error = inject(ErrorService).lastError;
  readonly showDetails = signal(false);

  constructor(
    private toasterSerivce: ToastrService,
    public store: MainStore,
    private authService: MsalService
  ) {

  }

  /** Pretty-printed raw response body for the expandable technical section (internal tool — safe to show). */
  technical(): string | null {
    const raw = this.error()?.raw as { error?: unknown } | undefined;
    const body = raw?.error ?? raw;
    if (!body) {
      return null;
    }
    try {
      return typeof body === 'string' ? body : JSON.stringify(body, null, 2);
    } catch {
      return null;
    }
  }

  randomIntFromInterval(min: number, max: number) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
 }

  ngOnInit(): void {
    this.failedJpg = `assets/failpics/${this.randomIntFromInterval(1, 100)}.jpg`;
      this.somethingwentwrong = 'assets/failpics/sowentwrong.png';
  }  

  getRandomePic() {
    this.flippic = !this.flippic;
    this.failedJpg = `assets/failpics/${this.randomIntFromInterval(1, 100)}.jpg`;    
  }
  
  showVersion()
  {
    this.toasterSerivce.info('Version: ' + environment.version);  
  }

  logout() {
    this.store.currentUser.clear();
    this.authService.logoutRedirect();
  }

}
